import api from '../api';

export default {
    async getDataNotifications(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            console.log('Fazendo requisição para /portal/notification com token:', accessToken ? 'disponível' : 'não disponível');
            const response = await api.get(`/portal/notification`,  {
                headers,
            });
            console.log('Resposta bruta da API:', response);
            console.log('Dados da resposta:', response.data);
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar as notificações:', error);
                throw error;
        }
    },
    async getNumberNotifications(accessToken) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.get(`/portal/notification/total-unread`,  {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao carregar quatidade de notificações:', error);
                throw error;
        }
    },
    async readNotification(accessToken, payload) {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json', 
            };
            const response = await api.post(`/portal/notificationuser`, payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao marcar notificação como lida:', error);
                throw error;
        }
    }

}

